import Axios from "axios";
import config from "../app.config";

export var mailTemplateService
export default mailTemplateService = {
  getListMailTemplate,
  deleteMailTemplate,
  addMailTemplate,
}

// list function
async function getListMailTemplate(data) {
  let user_id = data.user_id
  let queries = data.queries;
  return await Axios.get(`${config.LOCAL_API_URL}/mail-template/${user_id}`, { params: queries })
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    });
}

async function deleteMailTemplate(data) {
  let user_id = data.user_id;
  let id = data.id;
  return await Axios.delete(`${config.LOCAL_API_URL}/mail-template/${user_id}`, {
    data: { id }
  })
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    });
}

async function addMailTemplate(data) {
  let user_id = data.user_id;
  let { template_name, template_content, template_mode } = data;
  return await Axios.post(`${config.LOCAL_API_URL}/mail-template/${user_id}`,
    { template_name, template_content, template_mode })
    .then(response => {
      if (response.data) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    }).catch(error => {
      return Promise.reject(error);
    });
}

